module.exports = __webpack_public_path__ + "static/media/heart-filled@3x.55323a29.png";